var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-base-application',{attrs:{"title":"目標粗利率設定"}},[(_vm.enablePriceEvaluationForAdmin)?[_c('profit-settings',{ref:"ProfitSettings"})]:_c('base-alert',{attrs:{"type":"error"}},[_vm._v(" この機能をご利用いただくために、単価評価機能を有効にしてください。 ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }